const compareByTaskOrder = (a, b) => {
  const ao = a && Number.isFinite(a.taskOrder) ? a.taskOrder : 0;
  const bo = b && Number.isFinite(b.taskOrder) ? b.taskOrder : 0;

  if (ao !== bo) {
    return ao - bo;
  }

  const aId = a && a._id != null ? String(a._id) : '';
  const bId = b && b._id != null ? String(b._id) : '';
  return aId.localeCompare(bId);
};

module.exports = { compareByTaskOrder };
